import { connect } from 'react-redux'
import SubcontractorCell from './SubcontractorCell'

const mapStateToProps = () => ({
})

const actionCreators = {
}

export default connect(mapStateToProps, actionCreators)(SubcontractorCell)
